import useStyles from './Styles'
import React, { useState, useContext } from 'react'
import Provider, { MoreAboutMeContext, MoreAboutMeContextProvider } from './Provider'
import { Box } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { QuestionBlock, ParagraphQuestion, AsyncResponsesLoading } from 'components'
import { IProps } from './Interface'
import { handleEnterKey } from 'utils'
import cx from 'classnames'

interface IEdit {
  paragraphQuestion?: boolean
  askAbout?: boolean
  bestAttribute?: boolean
}

const MoreAboutMePage: React.FC<IProps> = ({ disabled }) => {
  const { state, handlers } = useContext<MoreAboutMeContext>(MoreAboutMeContextProvider)
  const [edit, setEdit] = useState({ paragraphQuestion: false, askAbout: false, bestAttribute: false } as IEdit)
  const theme = useTheme()
  const classes = useStyles({})

  return (
    <Box className={classes.root}>
      <Box className={cx(classes.paragraphQuestion, 'more-about-me-i-can-create-impact-on-section')}>
        <ParagraphQuestion
          edit={!disabled && edit.paragraphQuestion}
          onChange={handlers.handleChangeResponse}
          onClick={() => {
            handlers.handleUpdateResponses()
            setEdit({ paragraphQuestion: true })
          }}
          onClickOutside={(goToNextInput: boolean = false) => {
            handlers.handleUpdateResponses()
            setEdit({ paragraphQuestion: false, askAbout: goToNextInput })
          }}
          questions={[
            {
              questionKey: 'impactOn',
              label: 'I can create impact on',
              initialValue: state.impactOn
            },
            {
              questionKey: 'impactInterested',
              label: "because I'm interested in",
              initialValue: state.impactInterested
            },
            {
              questionKey: 'impactGoodAt',
              label: "because I'm motivated by",
              initialValue: state.impactGoodAt
            }
          ]}
        />
      </Box>

      <Box p={3}>
        <QuestionBlock
          className="more-about-me-if-you-want-to-get-me-talking-section"
          edit={!disabled && edit.askAbout}
          color={theme.palette.common.lightPurple}
          title={{ initialValue: 'If you want to get me talking ask me about…' }}
          detail={{
            limit: 140,
            questionKey: 'toGetMeTalking',
            initialValue: state.toGetMeTalking
          }}
          onChange={handlers.handleChangeResponse}
          onClick={() => {
            handlers.handleUpdateResponses()
            setEdit({ askAbout: true })
          }}
          onClickOutside={() => {
            handlers.handleUpdateResponses()
            setEdit({ askAbout: false })
          }}
          onKeyPressDetail={handleEnterKey(() => {
            handlers.handleUpdateResponses()
            setEdit({ askAbout: false, bestAttribute: true })
          })}
        />
        <QuestionBlock
          className="more-about-me-in-dealing-with-people-section"
          edit={!disabled && edit.bestAttribute}
          color={theme.palette.common.lightOrange}
          title={{ initialValue: 'In dealing with people, what’s your best attribute?' }}
          detail={{
            limit: 140,
            questionKey: 'inDealingWithPeople',
            initialValue: state.inDealingWithPeople
          }}
          onChange={handlers.handleChangeResponse}
          onClick={() => {
            handlers.handleUpdateResponses()
            setEdit({ bestAttribute: true })
          }}
          onClickOutside={() => {
            handlers.handleUpdateResponses()
            setEdit({ bestAttribute: false })
          }}
          onKeyPressDetail={handleEnterKey(() => {
            handlers.handleUpdateResponses()
            setEdit({ bestAttribute: false })
          })}
        />
      </Box>
    </Box>
  )
}

export default (props: IProps) => (
  <Provider {...props}>
    <AsyncResponsesLoading>
      <MoreAboutMePage {...props} />
    </AsyncResponsesLoading>
  </Provider>
)
